import { render, staticRenderFns } from "./inbound-tour.vue?vue&type=template&id=4e804b26&scoped=true"
import script from "./inbound-tour.vue?vue&type=script&lang=js"
export * from "./inbound-tour.vue?vue&type=script&lang=js"
import style0 from "./inbound-tour.vue?vue&type=style&index=0&id=4e804b26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e804b26",
  null
  
)

export default component.exports